import { Injectable } from '@angular/core';
import { EntityKey } from '@feature/pma-entity/pma-entity-types';
import {MojoWellKnownNames} from "@feature/common";
type RouteFragGenerator = (a: any) => string;

@Injectable({
  providedIn: 'root'
})
export class OverviewUrlService {
  private static readonly m = new Map<string, RouteFragGenerator>();

  constructor() {
    OverviewUrlService.m.set('Property', a => `/property/${a.Ref}`);
    OverviewUrlService.m.set('HeadLease', a => `/property/${a.PropertyRef}/headlease/${a.HeadLeaseRef}`);
    OverviewUrlService.m.set('Manager', a => `/manager/${a.Code}`);
    OverviewUrlService.m.set('Estate', a => `/estate/${a.Ref}`);
    OverviewUrlService.m.set('Tenant', a => `/tenant/${a.Ref}`);
    OverviewUrlService.m.set('TenantParent', a => `/tenant-parent/${a.Ref}`);
    OverviewUrlService.m.set('Unit', a => `/property/${a.PropertyRef}/unit/${a.UnitRef}`);
    OverviewUrlService.m.set('Vacant', a => `/property/${a.PropertyRef}/vacant/${a.UnitRef}`);
    OverviewUrlService.m.set('Lease', a => `/lease/${a.Ref}`);
    OverviewUrlService.m.set('ClientParent', a => `/client-parent/${a.Ref}`);
    OverviewUrlService.m.set('Client', a => `/client/${a.Ref}`);
    OverviewUrlService.m.set('Supplier', a => `/supplier/${a.Ref}`);
    OverviewUrlService.m.set('Creditor', a => `/creditor/${a.Uri}`);
    OverviewUrlService.m.set('Debtor', a => `/debtor/${a.Uri}`);
    OverviewUrlService.m.set('Landlord', a => `/landlord/${a.Ref}`);
    OverviewUrlService.m.set('Agreement', a => `/agreement/${a.Ref}`);
    OverviewUrlService.m.set('Account', a => `/account/${a.Uri}`);
  }

  /**
   * product specialization is due to route reuse (please see MojoRouteReuseStrategy).
   *
   * @param forProduct one of the product ids
   * @param type the entity type
   * @param key the entity ref(s)
   */
  getDashboardUrlFromEntityKey(forProduct: string, type: string, key: EntityKey): string {
    const productsRequiringEntityDataUrls: string[] = [
      MojoWellKnownNames.Products.MojoDashboard,
      MojoWellKnownNames.Products.Mci
    ]
    const url = OverviewUrlService.m.get(type)(key);
    return productsRequiringEntityDataUrls.includes(forProduct)
      ? `/entity-data${url}`
      : url;
  }
}
